import {
  Snackbar,
  Alert,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import { useEffect, useState } from "react";

import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";
import usePageTitle from "app/pageTitle";

import MDInput from "theme/components/MDInput";
import MDButton from "theme/components/MDButton";
import DataTable from "theme/Tables/DataTable";
import axios from "axios.js";
// import AppConfig from "appConfig";

function Users() {
  const pageTitle = "User Management";
  usePageTitle(pageTitle);

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };
  const [refreshPage, setRefreshPage] = useState(false);
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [openInviteDialog, setOpenInviteDialog] = useState(false);
  const [inviteName, setInviteName] = useState(null);
  const [inviteEmail, setInviteEmail] = useState(null);
  const [selectedRole, setSelectedRole] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [openChangeRoleDialog, setOpenChangeRoleDialog] = useState(false);

  async function updateUserStatus(ref) {
    setShowLoading(true);
    await axios
      .get(`/portal/users/${ref}/status/update.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function deleteUser(ref) {
    setShowLoading(true);
    await axios
      .get(`/portal/users/${ref}/delete.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function updateUserRole() {
    if (selectedUser === null) {
      setSeverity("error");
      setErrMsg("Please select a user to update.");
      setOpen(true);
      return;
    }

    if (selectedRole === null) {
      setSeverity("error");
      setErrMsg("Please select a role");
      setOpen(true);
      return;
    }
    setOpenChangeRoleDialog(false);
    setShowLoading(true);
    const json = {
      user: selectedUser,
      role: selectedRole,
    };
    await axios
      .post(`/portal/users/role/update.json`, json)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  const userTableColumns = [
    { Header: "Role", accessor: "role", align: "left" },
    { Header: "Last Name", accessor: "last_name", align: "left" },
    { Header: "First Name", accessor: "first_name", align: "left" },
    { Header: "Email", accessor: "email_address", align: "left" },
    { Header: "Phone Number", accessor: "phone_number", align: "left" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "Actions", accessor: "actions", align: "right" },
  ];

  const buildUserRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        role: row.role,
        last_name: row.last_name,
        first_name: row.first_name,
        email_address: row.email_address,
        phone_number: row.phone_number,
        status: (
          <MDBox>
            <Icon color={row.status ? "success" : "error"}>
              {row.status ? "check_circle" : "cancel"}
            </Icon>
          </MDBox>
        ),
        actions: (
          <MDBox mt={1} variant="button">
            <MDButton
              size="small"
              variant="outlined"
              color="info"
              iconOnly
              onClick={() => {
                if (
                  window.confirm(`${row.status ? "Disable" : "Enable"} ${row.first_name}?`) === true
                ) {
                  updateUserStatus(row.reference);
                }
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                {row.status ? "pause" : "play_arrow"}
              </Icon>
            </MDButton>
            &nbsp;&nbsp;
            <MDButton
              size="small"
              variant="outlined"
              color="warning"
              iconOnly
              onClick={() => {
                if (window.confirm(`Change ${row.first_name}'s role?`) === true) {
                  setSelectedUser(row.reference);
                  setOpenChangeRoleDialog(true);
                }
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                edit
              </Icon>
            </MDButton>
            &nbsp;&nbsp;
            <MDButton
              size="small"
              variant="outlined"
              color="error"
              iconOnly
              onClick={() => {
                if (window.confirm(`Delete ${row.first_name}?`) === true) {
                  deleteUser(row.reference);
                }
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                delete
              </Icon>
            </MDButton>
          </MDBox>
        ),
        // created: row.created,
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`/portal/SALES/users.json`)
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            console.log(result.data.data);
            setRoles(result.data.data.roles);
            const urows = buildUserRows(result.data.data.users);
            setUsers(urows);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  async function inviteUser() {
    if (inviteEmail === null) {
      setSeverity("error");
      setErrMsg("Email is required.");
      setOpen(true);
      return;
    }

    if (selectedRole === null) {
      setSeverity("error");
      setErrMsg("User's role is required.");
      setOpen(true);
      return;
    }

    setOpenInviteDialog(false);
    setShowLoading(true);
    const json = {
      email_address: inviteEmail,
      role: selectedRole,
      name: inviteName,
    };

    await axios
      .post("portal/users/invite.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={openInviteDialog} fullWidth maxWidth="sm">
        <DialogTitle>
          <MDBox>Invite User</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox sx={{ marginTop: "15px" }}>
            <MDBox mt={2}>
              <MDInput
                placeholder="Name"
                name="name"
                margin="dense"
                label="Name"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setInviteName(e.target.value)}
              />
            </MDBox>
            <MDBox mt={2}>
              <MDInput
                placeholder="Email Address"
                name="email_address"
                margin="dense"
                label="Email Address"
                type="email"
                fullWidth
                variant="outlined"
                onChange={(e) => setInviteEmail(e.target.value)}
              />
            </MDBox>
            <MDBox mt={3}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>User Role</InputLabel>
                <Select
                  label="User Role"
                  onChange={(e) => {
                    setSelectedRole(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  {
                    // --> Notice below changes
                    roles.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                      roles.map((record) => (
                        <MenuItem value={record.reference}>{record.title}</MenuItem>
                      ))
                  }
                </Select>
              </FormControl>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenInviteDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              inviteUser();
            }}
          >
            Invite User
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openChangeRoleDialog} fullWidth maxWidth="sm">
        <DialogTitle>
          <MDBox>Update User Role</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox sx={{ marginTop: "15px" }}>
            <MDBox mt={3}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>User Role</InputLabel>
                <Select
                  label="User Role"
                  onChange={(e) => {
                    setSelectedRole(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  {
                    // --> Notice below changes
                    roles.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                      roles.map((record) => (
                        <MenuItem value={record.reference}>{record.title}</MenuItem>
                      ))
                  }
                </Select>
              </FormControl>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenChangeRoleDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              updateUserRole();
            }}
          >
            Update Role
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDBox pt={0} pb={3}>
        <MDBox mt={0}>
          <Card sx={{ height: "100%", marginTop: "0px" }}>
            <MDBox>
              <MDBox p={2}>
                <MDBox display="flex" justifyContent="space-between" alignItems="center">
                  <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize" p={3}>
                    Users
                  </MDTypography>
                  <MDBox display="flex" justifyContent="space-evenly" alignItems="end">
                    <MDBox>
                      <MDButton
                        variant="contained"
                        color="dark"
                        iconOnly
                        onClick={() => {
                          setInviteEmail(null);
                          setSelectedRole(null);
                          setOpenInviteDialog(true);
                        }}
                      >
                        <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                      </MDButton>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDBox>
              <MDBox p={2}>
                <DataTable
                  table={{ columns: userTableColumns, rows: users }}
                  isSorted
                  entriesPerPage
                  showTotalEntries
                  buttons
                  noEndBorder
                />
              </MDBox>
            </MDBox>
          </Card>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Users;
